/*
 * Reeks-index: lazy-load the cover image for each series tile.
 *
 * Each tile links to its drill-down URL (?filter.p.m.custom.reeks=<value>).
 * We fetch that URL with &section_id=<Dawn product-grid section> (Section
 * Rendering API), which returns Dawn's product grid filtered to that reeks, and
 * grab the FIRST product image. That image is, by definition, the first item of
 * "this series within this category", so it is context-aware: comics under Oude
 * strips, drawings under Originele tekeningen, etc.
 *
 * Robust at any catalogue size (no Liquid 50-product cap). Degrades to the
 * spinner/placeholder if the fetch fails or the set has no image.
 */
(function () {
  'use strict';

  // Images live in Dawn's product grid section of the returned HTML.
  var PRODUCT_IMG_SELECTOR =
    '#product-grid img, .product-grid img, .card-product img, .card__media img';

  // Dawn's main-collection-product-grid section id (read once from the DOM).
  function gridSectionId() {
    var el = document.querySelector('[id^="shopify-section-"][id$="__product-grid"]');
    return el ? el.id.replace(/^shopify-section-/, '') : null;
  }

  function applyImage(tile, sourceImg) {
    var target = tile.querySelector('.collection-reeks__img');
    if (!target || !sourceImg) return false;

    var src = sourceImg.getAttribute('src');
    var srcset = sourceImg.getAttribute('srcset');
    if (!src && !srcset) return false;

    // Reveal (and stop the spinner) only once the cover has actually decoded,
    // so the alt text / broken-image never flashes.
    target.addEventListener('load', function () { tile.classList.add('is-loaded'); }, { once: true });
    target.addEventListener('error', function () { tile.classList.add('is-error'); }, { once: true });

    var sizes = sourceImg.getAttribute('sizes');
    if (sizes) target.setAttribute('sizes', sizes);
    if (srcset) target.setAttribute('srcset', srcset);
    if (src) target.setAttribute('src', src);

    // Already cached/complete (load event may not fire).
    if (target.complete && target.naturalWidth > 0) tile.classList.add('is-loaded');
    return true;
  }

  function loadTile(tile) {
    var url = tile.getAttribute('data-reeks-url');
    if (!url) { tile.classList.add('is-error'); return; }

    var gid = gridSectionId();
    if (gid) url += (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(gid);

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('reeks fetch ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var img = doc.querySelector(PRODUCT_IMG_SELECTOR);
        if (!applyImage(tile, img)) tile.classList.add('is-error');
      })
      .catch(function () {
        tile.classList.add('is-error'); // stop the spinner on failure
      });
  }

  function init() {
    // Only handle tiles we haven't observed yet (so hot-reload / section
    // re-renders re-process freshly injected tiles without double work).
    var tiles = document.querySelectorAll('[data-reeks-tile]:not([data-reeks-done])');
    if (!tiles.length) return;

    if (!('IntersectionObserver' in window)) {
      tiles.forEach(function (tile) {
        tile.setAttribute('data-reeks-done', '');
        loadTile(tile);
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            io.unobserve(entry.target);
            loadTile(entry.target);
          }
        });
      },
      { rootMargin: '300px 0px' }
    );

    tiles.forEach(function (tile) {
      tile.setAttribute('data-reeks-done', '');
      io.observe(tile);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when a section is (re)injected: theme editor + dev hot reload.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);

  // #5 Smooth-scroll to the product grid after a tile click.
  // Tiles do a full navigation, so we flag the click and scroll on the next load.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.collection-reeks__card')) {
      try { sessionStorage.setItem('reeksScroll', '1'); } catch (_) {}
    }
  });

  function maybeScrollToGrid() {
    var flag;
    try { flag = sessionStorage.getItem('reeksScroll'); } catch (_) {}
    if (!flag) return;
    try { sessionStorage.removeItem('reeksScroll'); } catch (_) {}
    if (document.documentElement.getAttribute('data-reeks-view') !== 'grid') return;
    var grid = document.querySelector('[id$="__product-grid"]');
    if (grid) setTimeout(function () { grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeScrollToGrid);
  } else {
    maybeScrollToGrid();
  }
})();
